const GEMINI_API_URL = "https://generativelanguage.googleapis.com/v1beta/models/gemini-3-flash-preview:generateContent";
const GEMINI_API_KEY = "AIzaSyBtVMwH4mAaTedRSdzSMuUsYGhbBoMbrsQ"; // User should replace this or use env

export async function chatWithGemini(messages, context) {
  const systemInstruction = `You are an expert LaTeX Copilot.
Your goal is to help users write and fix LaTeX documents.
Context of the current file:
---
${context?.relevantContext || "No context provided"}
---
Current cursor line: ${context?.cursorLine || "Unknown"}
Selected text: ${context?.selectedText || "None"}

Standard Formatting Rules:
1. Be concise.
2. If you want to suggest a specific text replacement, you MUST include a JSON block:
   \`\`\`json
   {
     "type": "suggestion",
     "startLine": 46,
     "endLine": 46,
     "suggestion": "replacement text",
     "description": "Fix reason"
   }
   \`\`\`
   Note: Use the absolute line numbers provided in the context.
3. For general advice, use regular markdown.
4. Try to make suggestions specific to the "Selected text" or "Current cursor line" if provided.`;

  const requestBody = {
    contents: [
      {
        role: "user",
        parts: [{ text: systemInstruction }]
      },
      ...messages.map(msg => ({
        role: msg.role === "assistant" ? "model" : "user",
        parts: [{ text: msg.content }]
      }))
    ],
    generationConfig: {
      temperature: 0.2,
      topK: 40,
      topP: 0.95,
      maxOutputTokens: 2048,
    }
  };

  try {
    const response = await fetch(`${GEMINI_API_URL}?key=${GEMINI_API_KEY}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error?.message || "Gemini API error");
    }

    const data = await response.json();
    return data.candidates[0].content.parts[0].text;
  } catch (error) {
    console.error("AI Service Error:", error);
    throw error;
  }
}
